<template>
    <v-app id="inspire">

      <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
        <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

          <v-container fluid fill-height align-start>
                <v-row  >
                    <v-col md="12" lg="12" cols="12">
                        <div>
                            <v-breadcrumbs :items="dbreads" large></v-breadcrumbs>
                        </div>

                        <v-alert
                                :value="alertnuevo"
                                color="primary"
                                dark
                                dismissible
                                border="top"
                                transition="scale-transition"
                        >
                            Su Contacto se agrego con éxito.
                        </v-alert>
                        <v-alert
                                :value="alerteditar"
                                color="green"
                                dark
                                dismissible
                                border="top"
                                transition="scale-transition"
                        >
                            Su Contacto se edito con éxito.
                        </v-alert>
                        <v-data-table
                                :headers="headers"
                                :items="Contactos"
                                sort-by="contacto"
                                sort-desc
                                class="elevation-1"
                                :search="search"
                                :loading="progr"
                                no-data-text="No hay datos disponibles para mostrar."
                                no-results-text="No hay resultados para la búsqueda."
                                loading-text="Cargando... Por favor espere."
                                style="background-color: #393E46;"
                        >
                            <template v-slot:top>
                                <v-toolbar flat >
                                    <v-toolbar-title>Contactos</v-toolbar-title>
                                    <v-progress-circular
                                            indeterminate
                                            v-if="progr == true"
                                            color="primary"
                                    ></v-progress-circular>
                                    <v-divider
                                            class="mx-4"
                                            inset
                                            vertical
                                    ></v-divider>
                                    <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                                    <v-spacer></v-spacer>
                                    <v-dialog v-model="dialog" max-width="500px">
                                        <template v-slot:activator="{ on }">
                                            <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo Contacto</v-btn>
                                        </template>
                                        <v-card  color="#393E46">
                                            <v-card-title>
                                                <span class="headline">{{ formTitle }}</span>
                                            </v-card-title>
                                            <v-card-text>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="12" sm="6" md="12">
                                                            <v-text-field v-model="editedItem.contacto" label="Nombre"></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                                                <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <v-icon
                                        small
                                        color="blue"
                                        class="mr-2"
                                        @click="editItem(item)"
                                >
                                    fas fa-edit
                                </v-icon>
                            </template>
                            <template v-slot:[`item.dactiva`]="{ item }">
                                <v-switch v-model="item.activo" @click="activaContacto(item)" ></v-switch>
                            </template>
                            <template v-slot:no-data>
                                <v-btn color="primary" @click="dameContactos">Cargar de Nuevo</v-btn>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
              <leftmenueventos :abreviado="abreviado" />

            </v-container>
        </v-main>
    </v-app>
</template>
<script>
    import { mapGetters } from "vuex";
    import leftmenueventos from '../../general/leftmenueventos';
    import axios from 'axios';
    import firebase from 'firebase/compat/app';
    import Cabecerabaja from "@/components/general/cabecerabaja";

    export default {
      title: 'Contactos | Tunay Mi acceso de bolsillo',

      components: {
        Cabecerabaja,
          leftmenueventos,
        },
        data: () => ({
            drawer: null,
            idnegocio: 0,
            dbreads: [
                {
                    text: 'Eventos',
                    disabled: true,
                    href: 'breadcrumbs_dashboard',
                },
                {
                    text: 'Contactos',
                    disabled: true,
                    href: 'breadcrumbs_link_2',
                },
            ],
            progr: true,
            alertborrador: false,
            alertnuevo: false,
            alerteditar: false,
            dialog: false,
          token:'',
            dialogdelete: false,
            date: new Date().toISOString().substr(0, 10),
            menu1: false,
          abreviado:'NN',

            Contactos: [],
            search: '',
            editedIndex: -1,
            editedItem: {
              id: 0,
              contacto: '',
              activo: false,
              cliente: {}
            },
            defaultItem: {
              id: 0,
              contacto: '',
              activo: false,
              cliente: {}
            },
            headers: [
                { text: 'Acciones', value: 'action', sortable: false },
                { text: 'Contacto', align: 'left',  value: 'contacto'},
                { text: 'Activo', value: 'dactiva' },
            ]
        }),
        mounted (){
           if (this.usuario.id === undefined){

             this.overlay = true
             firebase
                 .auth()
                 .onAuthStateChanged(user => {
                   if(user){
                     this.overlay = false
                     this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                     this.dameContactos();
                     this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
                   }else{
                     this.overlay = false
                     this.$router.push({ path: '/' });
                   }
                 })
           }else{
             this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
             this.dameContactos();
             this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
          }
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
            "$route.params.idnegocio"(value) {
                console.log(value);
              if (this.usuario.id === undefined){
                this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                this.dameContactos();
              }else{
                this.$router.push({ path: '/' });

              }
            },
        },
        methods : {
            dameContactos(){
                this.progr = true;
                let urlContacto = 'contactos/cliente/' + this.cliente.id ;
                axios
                    .get(urlContacto)
                    .then(response => {
                        this.Contactos = response.data;
                        this.progr = false;
                        this.alertborrador = false;
                        this.alertnuevo = false;
                        this.alerteditar = false;
                    })
                    .catch((error)  => {
                        console.log(error);
                      this.progr = false;
                    });
            },
            editItem (item) {
                this.editedIndex = this.Contactos.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },
            deleteItem (item) {
                this.editedIndex = this.Contactos.indexOf(item);
                this.dialogdelete = true;
            },
            activaContacto (item) {
                this.editedItem = Object.assign({}, item)
              var bodyFormData2 = new FormData();
              bodyFormData2.append("data",JSON.stringify(this.editedItem));
                axios
                    .post('contactos/grabar',bodyFormData2,{
                      headers: {
                        'Authorization': `Bearer ${this.token}`,
                      }
                    }).then(response => {
                    console.log(response);
                })
                    .catch(error => {
                        this.error = "Hubo un error";
                        console.log(error);
                    });
            },
            close () {
                this.dialog = false;
                this.dialogdelete = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },
            save () {
              var bodyFormData2 = new FormData();
                if (this.editedIndex > -1) {
                    Object.assign(this.Contactos[this.editedIndex], this.editedItem);

                  bodyFormData2.append("data",JSON.stringify(this.editedItem));
                    axios
                        .post('contactos/grabar',bodyFormData2,{
                          headers: {
                            'Authorization': `Bearer ${this.token}`,
                          }
                        }).then(response => {
                        console.log(response);
                        this.alerteditar = true;
                        this.dameContactos();
                    })
                        .catch(error => {
                            this.error = "Hubo un error";
                            console.log(error);
                        });
                } else {
                  this.editedItem.cliente = this.cliente
                  this.editedItem.activo = true
                  this.editedItem.id = null
                  bodyFormData2.append("data",JSON.stringify(this.editedItem));
                    axios
                        .post('contactos/grabar',bodyFormData2,{
                          headers: {
                            'Authorization': `Bearer ${this.token}`,
                          }
                        }).then(response => {
                        this.dameContactos();
                        this.alertnuevo = true;
                        console.log(response);
                    })
                        .catch(error => {
                            this.error = "Hubo un error";
                            console.log(error);
                        });
                }
                this.close()
            },
        },
        computed: {
            // map `this.user` to `this.$store.getters.user`
            formTitle () {
                return this.editedIndex === -1 ? 'Nueva Contacto' : 'Editar Contacto'
            },
            computedDateFormatted () {
                return this.formatDate(this.date)
            },
            ...mapGetters({
                user: "user",
                usuario: "usuario",
              cliente: "cliente"
            })
        }
    };
</script>